import { useEffect, useId, useRef, useState } from "react";
import { api } from "../../api.js";

// Поле з підказками (комбобокс): ↑/↓ — вибір, Enter — підставити, Escape — закрити.
// load(q) → Promise<items>; підказки лише допомагають — значення поля завжди можна ввести вручну
export function SuggestInput({ id, value, onChange, onPick, load, render, minLength = 2, placeholder, inputMode, invalid, describedBy, label }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const [typed, setTyped] = useState(false);
  const listId = useId(), root = useRef(null);
  useEffect(() => {
    if (!typed || String(value || "").trim().length < minLength) { setItems([]); return; }
    let live = true;
    const t = setTimeout(() => load(String(value).trim()).then((x) => { if (live) { setItems(x || []); setActive(0); } }).catch(() => live && setItems([])), 220);
    return () => { live = false; clearTimeout(t); };
  }, [value, typed]);
  useEffect(() => {
    const out = (e) => { if (!root.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("pointerdown", out);
    return () => document.removeEventListener("pointerdown", out);
  }, []);
  const show = open && items.length > 0;
  const pick = (it) => { onPick(it); setOpen(false); setTyped(false); setItems([]); };
  const onKey = (e) => {
    if (!show) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((i) => Math.min(items.length - 1, i + 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setActive((i) => Math.max(0, i - 1)); }
    else if (e.key === "Enter") { e.preventDefault(); pick(items[active]); }
    else if (e.key === "Escape") { e.preventDefault(); setOpen(false); }
  };
  return (
    <div className="suggest" ref={root}>
      <input id={id} value={value} placeholder={placeholder} inputMode={inputMode} autoComplete="off"
        aria-label={label} aria-invalid={invalid || undefined} aria-describedby={describedBy}
        role="combobox" aria-expanded={show} aria-controls={listId} aria-autocomplete="list"
        aria-activedescendant={show ? `${listId}-${active}` : undefined}
        onChange={(e) => { onChange(e.target.value); setTyped(true); setOpen(true); }} onFocus={() => setOpen(true)} onKeyDown={onKey} />
      {show && (
        <ul className="suggest-list" id={listId} role="listbox">
          {items.map((it, i) => (
            <li key={i} id={`${listId}-${i}`} role="option" aria-selected={i === active} className={i === active ? "active" : ""}
              onMouseEnter={() => setActive(i)} onMouseDown={(e) => { e.preventDefault(); pick(it); }}>{render(it)}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

// Пошук кодів у довідниках: товар — УКТЗЕД, послуга — ДКПП
export const loadCodes = (service) => (q) => api(`/api/ref/search?q=${encodeURIComponent(q)}`)
  .then((r) => (service ? r.dkpp.map((x) => ({ code: x.code, title: x.name })) : r.uktzed.filter((x) => x.is_leaf !== false).map((x) => ({ code: x.code, title: x.short }))).slice(0, 12));
